import React from 'react';

interface PopUpProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  cancelText: string;
  confirmText: string;
  children?: React.ReactNode;
  isConfirmDisabled?: boolean;
}

const PopUp: React.FC<PopUpProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  cancelText,
  confirmText,
  children,
  isConfirmDisabled = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-[2px] flex items-center justify-center z-50 animate-fadeIn">
      <div className="bg-white/95 rounded-3xl p-8 w-[600px] mx-4 shadow-[0_8px_30px_rgb(0,0,0,0.12)] backdrop-blur-sm animate-popUp">
        <div className="text-left">
          <h2 className="text-[24px]  font-bold leading-[32.74px] tracking-[0.02em] text-[#222222] mb-2">
            {title}
          </h2>
          <p className="text-[#9EA0A0]  text-[14px] font-light leading-[19.1px] tracking-[0.03em] mb-4">
            {message}
          </p>
        </div>
        
        {children}
        
        <div className="flex justify-end gap-3 mt-4">
          <button
            onClick={onClose}
            className="px-6 py-3 rounded-full text-[#7A7A7A] hover:bg-gray-100 transition-colors text-[14px] "
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            disabled={isConfirmDisabled}
            className={`px-6 py-3 rounded-full transition-colors text-[14px]  ${
              isConfirmDisabled 
                ? 'bg-gray-200 text-gray-500 cursor-not-allowed' 
                : 'bg-[#42E56F] hover:bg-[#22c55e] text-black'
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopUp;
